import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { IClinicToDoctorRequestItem } from "./useClinicToDoctorRequestListAPI";

interface IGetRequestResponse {
  status: boolean;
  message: string;
  data: IClinicToDoctorRequestItem;
}

export const useGetClinicToDoctorRequestAPI = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IClinicToDoctorRequestItem | null>(null);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (requestId: string) => {
    setLoading(true);
    setData(null);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const res = await axios.get<IGetRequestResponse>(
        `${INVENTORY_MODULE.CLINIC_TO_DOCTOR_REQUEST.baseURL}/${requestId}`,
        {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (res.data.status === true) {
        setData(res.data.data);
      } else {
        toast.error(res.data.message || "Failed to fetch request");
      }
    } catch (e: AxiosError | any) {
      captureError(e);
      toast.error("Failed to fetch request details");
    } finally {
      setLoading(false);
    }
  }, []);

  return { execute, data, loading };
};
